module.exports = __webpack_public_path__ + "img/fila-1-puzzle-3.b00ada08.png";